import {
    tss,
} from 'app/tss'

export default tss.create(({
    theme,
}) => {
    return {
        filterIcon: {
            color: theme.palette.secondary[600],
            height: '17px !important',
            width: '17px !important',
        },
    }
})
